<template>
  <aside class="sidebar">
    <ul class="sidebar-list">
      <li class="sidebar-list-item">
        <img src="/images/profile-photo.svg" alt="profile photo" />
        <p class="user-name">
          {{displayName }}
        </p>
      </li>

      <router-link class="sidebar-list-item" :to="{ name: 'UserOrders' }">
        <li>
          <div class="container">
            <img src="/images/download.svg" alt="download" />
            My orders
          </div>
        </li>
      </router-link>

      <router-link class="sidebar-list-item" :to="{ name: 'RecentlyViewed'}">
        <li>
          <div class="container">
            <img src="/images/opnEye.svg" alt="open eye" />
            Recently viewed
          </div>
        </li>
      </router-link>

      <router-link :to="wishlistRoute" class="sidebar-list-item">
        <li>
          <div class="container wish-container">
            <img src="/images/heart.svg" alt="heart" />
            Wishlist
          </div>
        </li>
      </router-link>

      <router-link to="/404" class="sidebar-list-item">
        <li>
          <div class="container wish-container">
            <img src="/images/question.svg" alt="question mark" />
            Help
          </div>
        </li>
      </router-link>

      <router-link to="/404" class="sidebar-list-item">
        <li>
          <div class="container wish-container">
            <img src="/images/clarity_settings-line.svg" alt="settings" />
            Settings
          </div>
        </li>
      </router-link>
    </ul>
  </aside>
</template>
  
  <script>
export default {
  props: {
    user: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  mounted() {
    console.log("User prop:", this.user);
  },
  computed: {
    userId() {
      return this.$store.getters.userData
        ? this.$store.getters.userData.id
        : "guest";
    },

    displayName() {
      return this.user?.displayName || "Anonymous";
    },

    wishlistRoute() {
      return `/Wishlist/${this.userId}`;
    },
  },
};
</script>
  
<style scoped>
ul {
  list-style-type: none;
}
.sidebar {
  width: clamp(20rem, 25rem, 35rem);
  margin-bottom: 15px;
}
.sidebar-list-item:nth-child(1) {
  height: 14rem;
  background: #e5e5e5;
}

.sidebar-list-item:nth-child(n + 2) {
  height: 7.2rem;
  background: #fafafa;
}
.sidebar-list-item {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 15px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px 20px;
  font-family: "Mabry Pro";
  color: #000;
  font-size: 1.8rem;
  font-weight: 500;
  justify-content: space-between;
}
.container {
  display: flex;
  gap: 15px;
  align-items: center;
}

.wish-container {
  display: flex;
  gap: 15px;
  align-items: center;
}
</style>
  